import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NgClass, NgIf, NgStyle} from '@angular/common';

import {
  InteractionAnswerSaveDto,
  InteractionCardDto
} from '../../models/card.model';

import {CardWrapperComponent} from '../card-wrapper/card-wrapper.component';
import {CardQuestionnaireComponent} from '../card-questionnaire/card-questionnaire.component';
import {CardAudioComponent} from '../card-audio/card-audio.component';
import {CardFormComponent} from '../card-form/card-form.component';
import {CardRatingComponent} from '../card-rating/card-rating.component';
import {CardRoleplayComponent} from '../card-roleplay/card-roleplay.component';
import {CardReorderComponent} from '../card-reorder/card-reorder.component';
import {CardTextComponent} from '../card-text/card-text.component';
import {CardResultsComponent} from '../card-results/card-results.component';
import {CardVideoComponent} from '../card-video/card-video.component';
import {CardButtonComponent} from '../card-button/card-button.component';
import {CardDragToGroupComponent} from '../card-drag-to-group/card-drag-to-group.component';
import {CardDragAndMatchComponent} from '../card-drag-and-match/card-drag-and-match.component';
import {CardTitleComponent} from '../card-title/card-title.component';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
  standalone: true,
  imports: [
    NgStyle, NgClass, NgIf,
    CardWrapperComponent,
    CardQuestionnaireComponent,
    CardRatingComponent,
    CardAudioComponent,
    CardFormComponent,
    CardRoleplayComponent,
    CardReorderComponent,
    CardTextComponent,
    CardResultsComponent,
    CardButtonComponent,
    CardVideoComponent,
    CardDragToGroupComponent,
    CardDragAndMatchComponent, CardTitleComponent],
})
export class CardComponent implements OnInit {

  @Output() onSubmit = new EventEmitter<InteractionAnswerSaveDto>();

  @Input() set card(card: InteractionCardDto) {
    this.isVideo = !card.isRolePlay && card.type !== 'audio' && !!card.url1;
    this.initIsWaitingRolePlay(card);

    this._card = card;
    console.log('activeCard', this._card);
  }

  @Input() set isResults(isResults: boolean) {
    this._isResults = isResults;
    this.initIsWaitingRolePlay(this._card);
  }

  @Input() isWordCloudReady: boolean = false;

  _isResults: boolean = false;

  _card: InteractionCardDto;
  isVideo = false;
  isWaitingRolePlay = false;

  constructor() {
  }

  ngOnInit() {
  }

  initIsWaitingRolePlay(card: InteractionCardDto) {
    this.isWaitingRolePlay = !this._isResults && (!card.cardAnswer || !card.cardAnswer.isCompleted) && (card.isRolePlay || (this.isVideo && card.type !== 'video'));
  }

  onPlayFinishedHandler(status: boolean) {
    this.isWaitingRolePlay = false;
  }

  onSubmitHandler(payload: InteractionAnswerSaveDto) {
    this.onSubmit.emit(payload);
  }
}
